import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import { ImageUrl } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import OneImg from "../../../../../Assets/img/one.png"
import TwoImg from "../../../../../Assets/img/two.webp"
import ThreeImg from "../../../../../Assets/img/three.webp"
import FourImg from "../../../../../Assets/img/four.webp"
import FiveImg from "../../../../../Assets/img/five.webp"
import { Link } from "react-router-dom";
import { isMobileOnly } from "react-device-detect";


const imageData = [
    {
        img: OneImg,
        title: "Image One",
        url: "/jewelry/fine-jewelry",
    },
    {
        img: TwoImg,
        title: "Image Two",
        url: "/jewelry/fine-jewelry",
    },
    {
        img: ThreeImg,
        title: "Image Three",
        url: "/jewelry/fine-jewelry",
    },
    {
        img: FourImg,
        title: "Image Four",
        url: "/jewelry/fine-jewelry",
    },
    {
        img: FiveImg,
        title: "Image Five",
        url: "/jewelry/fine-jewelry",
    },

];

const Vintage = () => {
    var settings = {
        dots: true,
        infinite: true,
        arrows: true,
        speed: 500,
        accessibility: true,
        autoplay: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025, // 👈 iPad view
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true, // hide arrows on iPad
                },
            },

            {
                breakpoint: 992, // 👈 iPad view
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true, // hide arrows on iPad
                },
            },

            {
                breakpoint: 600, // mobile
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    arrows: false,// hide arrows on iPad
                },
            },
        ],
        beforeChange: (current, next) => {
            document
                .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
                .forEach(el => el.setAttribute('tabindex', '-1'));
        },
        afterChange: () => {
            document
                .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
                .forEach(el => el.removeAttribute('tabindex'));
        }
    };

    return (
        <section
            className="py-5 noBgImage ptMob30 pbMob30"
        >
            <Container className="py-lg-5 vintageContainer">
                <div className="text-center mx-auto mb-lg-5 mb-xl-5 mb-sm-2">
                    <h3 className="title_heading mb-0 pb-0 d-block text-uppercase fontMessiri">
                        Vintage Jewelry
                    </h3>
                    <p className="VintageTitleP">
                        Shop our showroom in Star and visit our Instagram page for more
                    </p>
                </div>
                <Row className="justify-content-center">
                    <Col lg={12} xs={12} className="vintageSlider">
                        <Slider {...settings} className="overflow-hidden shapeBySl ">

                            {imageData.map(({ img, title, url }, index) => (
                                <div className="VintageContainer">
                                    <div className="VintageBox" key={index}>
                                        <Link to={url}>
                                            <img src={img} alt={title} />
                                        </Link>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Vintage;
